"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import HtmlEmbed from "./webflow_modules/Embed/components/HtmlEmbed";
import Link from "./webflow_modules/Basic/components/Link";

export function AdvSearchOpenCloseMapToggle({
  showCloseButton = true,
  toggleMapButtonProps = {},
}) {
  return (
    <Block className={"map-button-open-close-component"} tag={"div"}>
      <Link
        aria-label={"Show Interactive Map"}
        block={"inline"}
        button={false}
        className={"map-button-show-map-icon"}
        options={{
          href: "#",
        }}
        {...toggleMapButtonProps}
      >
        <HtmlEmbed
          className={"icon-embed-xsmall mobile-small blue"}
          content={
            '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="iconify iconify--iconoir" width="100%" height="100%" preserveaspectratio="xMidYMid meet" viewbox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m9 19l-5.21 1.737a.6.6 0 0 1-.79-.57V5.433a.6.6 0 0 1 .41-.569L9 3m0 16l6 2m-6-2V3m6 18l5.59-1.863a.6.6 0 0 0 .41-.57V3.832a.6.6 0 0 0-.79-.569L15 5m0 16V5m0 0L9 3"/></svg>'
          }
        />
      </Link>
      {showCloseButton ? (
        <Link
          aria-label={"Close Interactive Map"}
          block={"inline"}
          button={false}
          className={"map-button-show-close-icon"}
          options={{
            href: "#",
          }}
          {...toggleMapButtonProps}
        >
          <HtmlEmbed
            className={"icon-embed-xsmall---rotate-45"}
            content={
              '<svg xmlns="http://www.w3.org/2000/svg" fill="%23333" viewbox="0 0 29 29"><path fill="currentColor" d="M14.5 8.5c-.75 0-1.5.75-1.5 1.5v3h-3c-.75 0-1.5.75-1.5 1.5S9.25 16 10 16h3v3c0 .75.75 1.5 1.5 1.5S16 19.75 16 19v-3h3c.75 0 1.5-.75 1.5-1.5S19.75 13 19 13h-3v-3c0-.75-.75-1.5-1.5-1.5z"/></svg>'
            }
          />
        </Link>
      ) : null}
    </Block>
  );
}
